module.exports = __webpack_public_path__ + "static/e-commerce-tablet-app-cover-7185fde5296ace9aaf00235586bb0a25.png";